import React from 'react';
import { IconLeft4, IconRight4 } from '@99designs/icons';

interface Props {
    handlePrevClick: () => void;
    handleNextClick: () => void;
}

const CarouselTriggers = ({ handlePrevClick, handleNextClick }: Props) => {
    return (
        <>
            <button
                className="carousel__content__prev-trigger"
                onClick={handlePrevClick}
                aria-label="Previous"
            >
                <IconLeft4 />
            </button>
            <button
                className="carousel__content__next-trigger"
                onClick={handleNextClick}
                aria-label="Next"
            >
                <IconRight4 />
            </button>
        </>
    );
};

export default CarouselTriggers;
